<template>
	<div id="app">

		<Header />

		<router-view></router-view>

		<Footer />

	</div>
</template>

<script>
import Header from "./views/partials/Header.vue";
import Footer from "./views/partials/Footer.vue";

export default {
	name: "App",
	data () {
		return {

		}
	},
	components: {
		Header,
		Footer
	}
};
</script>

<style lang="scss">
.grecaptcha-badge {

	display: none !important;
}
</style>
